import * as React from 'react';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {LoadingPage} from 'shells/loading-page/loading-page';

import {useGetAvailablePhoneNumbers, useGetInboxStatus} from '../../graphql/hooks';
import {getPhoneNumber} from '../../helpers';

import {AreaCode} from './area-code';
import {SelectNumber} from './select-number';
import {SuccessState} from './success-state';

type Props = {
    startedFrom: 'marketing' | 'engagement';
};

export function PhoneNumber(props: Props) {
    const [areaCode, setAreaCode] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [phoneNumbers, setPhoneNumbers] = React.useState([]);
    const [isGenerating, setIsGenerating] = React.useState(false);
    const {inboxStatus, isLoading, refetch: refetchInboxStatus} = useGetInboxStatus();

    const selectedPhoneNumber = getPhoneNumber(inboxStatus);

    const {refetch: generateAvailablePhoneNumbers} = useGetAvailablePhoneNumbers(
        parseInt(areaCode)
    );

    const handleGenerateNumbers = () => {
        if (areaCode.length < 3) {
            setErrorMessage('Area code must be 3 digits');
        }

        if (areaCode.length === 3) {
            setIsGenerating(true);

            generateAvailablePhoneNumbers()
                .then((res) => {
                    setIsGenerating(false);
                    const availablePhoneNumbers = res && res.data && res.data.availablePhoneNumbers;
                    if (availablePhoneNumbers) {
                        // @ts-expect-error
                        setPhoneNumbers(availablePhoneNumbers);
                    }
                })
                .catch((err) => {
                    setIsGenerating(false);
                    const error = safelyGetGraphQLErrorMessage(err);
                    if (error) {
                        setErrorMessage(error);
                    }
                });
        }
    };

    return (
        <>
            {isLoading && <LoadingPage />}
            {!isLoading && selectedPhoneNumber && (
                <SuccessState
                    selectedPhoneNumber={selectedPhoneNumber}
                    startedFrom={props.startedFrom}
                />
            )}
            {!isLoading && !selectedPhoneNumber && phoneNumbers && phoneNumbers.length > 0 && (
                <SelectNumber
                    phoneNumbers={phoneNumbers}
                    onGenerateNumbers={handleGenerateNumbers}
                    isGenerating={isGenerating}
                    refetchInboxStatus={refetchInboxStatus}
                />
            )}
            {!isLoading && !selectedPhoneNumber && (!phoneNumbers || phoneNumbers.length === 0) && (
                <AreaCode
                    areaCode={areaCode}
                    setAreaCode={setAreaCode}
                    onGenerateNumbers={handleGenerateNumbers}
                    isGenerating={isGenerating}
                    errorMessage={errorMessage}
                />
            )}
        </>
    );
}
